import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./global-components";
import "./utils";
import "./libs";

// Midone Theme
import "./assets/sass/app.scss";

Vue.config.productionTip = false;

// 기간 삭제(차단) 목록에 포함된 날짜를 모든 el-date-picker에서 비활성화하기 위한 공통 옵션
Vue.mixin({
  computed: {
    deletedPeriodPickerOptions() {
      const periods = this.$store.state.main.deletedPeriods || [];
      return {
        disabledDate(date) {
          const y = date.getFullYear();
          const m = String(date.getMonth() + 1).padStart(2, "0");
          const d = String(date.getDate()).padStart(2, "0");
          const s = `${y}-${m}-${d}`;
          return periods.some(p => p.startDay <= s && s <= p.endDay);
        }
      };
    }
  },
  methods: {
    // 빠른검색(1주일/1개월/3개월/6개월) 범위가 차단 기간과 겹치면 버튼 숨김용 false 반환
    // days는 각 화면 calc 함수의 오프셋과 동일하게: 7 / 30 / 92 / 184
    isQuickRangeAllowed(days) {
      const periods = this.$store.state.main.deletedPeriods || [];
      const fmt = d =>
        `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
      const now = new Date();
      const endStr = fmt(now);
      const startStr = fmt(new Date(now.getTime() - 3600 * 1000 * 24 * days));
      return !periods.some(p => p.startDay <= endStr && p.endDay >= startStr);
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
